export const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1;
